export default __webpack_public_path__ + "static/media/1957-desktop.37313672.jpg";